import { useAuth } from '@/contexts/AuthContext';

export const useDemoMode = () => {
  const { user } = useAuth();
  
  const isDemoUser = user?.email === 'peodemo@thepeoapp.com';
  
  // Demo users get access to enterprise features
  const hasEnterpriseFeatures = isDemoUser;
  
  // Demo users should always be considered as having verified email
  const isEmailVerifiedOverride = isDemoUser;
  
  return {
    isDemoUser,
    hasEnterpriseFeatures,
    isEmailVerifiedOverride,
    demoProviderName: 'Demo PEO Solutions (Enterprise Demo)',
    demoFeatures: {
      advancedAnalytics: isDemoUser,
      customBranding: isDemoUser,
      prioritySupport: isDemoUser,
      advancedReporting: isDemoUser,
      apiAccess: isDemoUser,
      multiStateSupport: isDemoUser,
      dedicatedAccountManager: isDemoUser,
    }
  };
};